import React, { useEffect, useState } from 'react';
import { Space, Button, Loader, openNotification, Tabs } from 'tt-ui-lib/core';
import { AddIcon, RightIcon } from 'tt-ui-lib/icons';
import TemplateModal from '../modals/Template';
import ManageModal from '../modals/Manage';
import { fetchTemplates } from 'api/admin/endpoints/mailing';
import styles from '../../Communications.module.scss';

const ExpandIcon = ({ isActive }) => (
  <RightIcon
    style={{
      display: 'block',
      marginTop: 10,
      width: 20,
      height: 20,
      transform: `rotate(${isActive ? 90 : 0}deg)`,
    }}
  />
);

const TemplatesTabs = () => {
  const [templates, setTemplates] = useState([]);
  const [open, setOpen] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);

  const openEditModal = (id) => {
    setEditId(id);
    setIsEdit(true);
    setOpen(true);
  };

  const platformTabs = [
    { id: 'transparent', name: 'Transparenterra' },
    { id: 'shopping', name: 'Greenify Shopping' },
    { id: 'marketing', name: 'Greenify Marketing' },
  ];

  const getTemplates = () => {
    const platform = platformTabs[selectedTab]?.id;
    fetchTemplates(0, 1000, platform)
      .then((res) => {
        setTemplates(
          (res.data?.data?.templates || []).map((item) => ({
            label: <b>{item.name}</b>,
            onClick: () => {
              openEditModal(item.id);
            },
          }))
        );
      })
      .catch(() => {
        openNotification({
          type: 'error',
          message: 'Failed to fetch templates',
        });
      })
      .finally(() => setIsLoading(false));
  };

  const onUpdate = () => {
    setIsUpdate(true);
  };

  useEffect(() => {
    setIsLoading(true);
    getTemplates();
    if (isUpdate) {
      setIsUpdate(false);
    }
  }, [selectedTab, isUpdate]);

  useEffect(() => {
    if (!open && isEdit) {
      setIsEdit(false);
      setEditId(null);
    }
  }, [open]);

  return (
    <>
      <Tabs
        tabs={platformTabs}
        selectedTab={selectedTab}
        onChangeTab={setSelectedTab}
        style={{ marginBottom: 20 }}
      />

      <Space style={{ width: '100%', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div />

        <Space>
          <Button onClick={() => setManageOpen(true)}>Manage</Button>

          <Button
            className="icon-white-fill"
            type="primary"
            onClick={() => setOpen(true)}
            icon={<AddIcon style={{ width: 20, height: 20 }} />}
          >
            Add new template
          </Button>
        </Space>
      </Space>

      {isLoading ? (
        <div
          style={{
            width: '100%',
            height: '100px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Loader />
        </div>
      ) : templates.length > 0 ? (
        templates.map((item) => (
          <div className={styles.templateItem} key={item.id} onClick={item.onClick}>
            <b>{item.label}</b>
            <div>
              <ExpandIcon />
            </div>
          </div>
        ))
      ) : (
        <div>No templates found</div>
      )}

      <TemplateModal
        open={open}
        setOpen={setOpen}
        onUpdate={onUpdate}
        isEdit={isEdit}
        editId={editId}
      />

      <ManageModal open={manageOpen} setOpen={setManageOpen} />
    </>
  );
};

export default TemplatesTabs;
